export default __webpack_public_path__ + "static/media/menu-arrow-left.57f046fc.svg";